// Consolidated-report rows carry a composite id of the form
// "<PREFIX>-<entityId>-<memberId>" (e.g. "LVP-9-7", "ACT-3-7"), built by the
// backend EffortAdapter. This returns the entity id (the segment after the
// prefix) as a number, or null when it is missing or non-numeric. Falls back to
// the whole id for a plain, unprefixed value.
// @since NEXT_VERSION
export const parseReportRowEntityId = (rowId) => {
  if (!rowId) return null;
  const parts = String(rowId).split("-");
  const parsed = parseInt(parts[1] ?? rowId, 10);
  return Number.isNaN(parsed) ? null : parsed;
};
